import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Form, Button, Spinner } from "react-bootstrap";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { useLazyQuery } from "@apollo/client";
import { GET_BANKS } from "../../apollo/bank/query";
import { S3_URL } from "../../const";
import { convertCurrency, covertTimeZone, numberFormat } from "../../helper";

export default function BillOfferPriceV3({ shopData, orderGroupData, titleBill }) {

    // console.log("shopData: ", shopData)
    // states
    const [categories, setCategories] = useState([])
    const [categoriesPrepare, setCategoriesPrepare] = useState(null)
    const [bankAccount, setBankAccount] = useState([])

    // apollo client hooks
    const [loadCategoryData, { data: getCategoryData, loading: loadingLoadCategory }] = useLazyQuery(
        GET_CATEGORYS,
        { fetchPolicy: "cache-and-network" }
    );
    const [getBank, { data: getbankData, loading: loadingBanks }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });


    // useEffect hooks
    useEffect(() => {
        if (getCategoryData) {
            setCategories(getCategoryData?.categories?.data);
            setCategoriesPrepare(getCategoryData?.categories?.data[0]);
        }
    }, [getCategoryData]);

    useEffect(() => {
        if (getbankData) {
            setBankAccount(getbankData?.banks?.data);
        }
    }, [getbankData]);

    useEffect(() => {
        handleFactCategorys()
        _fetchBank()
    }, [shopData])


    // fetch bank datas
    const _fetchBank = async () => {

        try {
            await getBank({
                variables: {
                    limit: 100,
                    orderBy: "createdAt_DESC",
                    where: {
                        shop: shopData?.id,
                        isDeleted: false,
                    },
                },
            });
        } catch (error) {
            console.log(error)
        }
    };
    // functions get catetgories datas
    const handleFactCategorys = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (loadingLoadCategory) return
        try {

            await loadCategoryData({
                variables: {
                    limit: null,
                    where: {
                        isDeleted: false,
                        orderBy: "createdAt_DESC",
                        shop: localData?.id,
                    },
                },
            });

        } catch (error) {
            console.log({ error })
        }
    }

    // split catetory and set new data
    const handleChangeCategory = (values) => {
        // find categories data where id in values
        let _categoriesData = categories?.filter((category) => values?.includes(category?.id))
        setCategoriesPrepare(_categoriesData[0])
    }

    const orderLists = orderGroupData?.offerprices || orderGroupData?.orders;

    return (
        <div className="min-h-screen bg-white">
            <Card className="mx-auto max-w-5xl" style={{ border: 'none' }}>
                <Card.Header className="d-flex justify-content-between align-items-center" style={{ border: 'none' }}>
                    <div />
                    <div className="d-flex align-items-center gap-4">
                        <img
                            src={S3_URL + shopData?.image}
                            alt="Logo"
                            className="object-contain"
                            style={{ width: "auto", height: 100 }}
                        />
                        <div>
                            <h2 className="h4">{titleBill}</h2>
                        </div>
                    </div>
                    <div className="text-end">
                        <Form.Group>
                            <Form.Label>ປະເພດສິນຄ້າ</Form.Label>
                            {loadingLoadCategory ? <Spinner animation="border" size="sm" /> : <Form.Control as="select" onChange={(e) => handleChangeCategory(e?.target?.value)} defaultValue="default">
                                {categories.map((option, _index) => (
                                    <option key={_index} value={option?.id}>{option?.name}</option>
                                ))}
                            </Form.Control>}
                        </Form.Group>

                    </div>
                </Card.Header>
                <Card.Body>
                    <Row className="mb-4">
                        <Col md={6} style={{ lineHeight: 0.5 }}>
                            <h5>{categoriesPrepare?.companyOption ?? "....................."}</h5>
                            <p>{categoriesPrepare?.addressOption ?? "....................."}</p>
                            <p>{categoriesPrepare?.phoneOption ?? "....................."}</p>
                            <p>{categoriesPrepare?.emailOption ?? ""}</p>
                            <p>{categoriesPrepare?.websiteOption ?? ""}</p>
                        </Col>
                        <Col md={6}>
                            <br />
                            <p>ໝາຍເຫດ:..........................................</p>
                            <br />
                            <Row>
                                <Col>
                                    <p>ເລກໃບບິນ</p>
                                </Col>
                                <Col>
                                    <p>ວັນທີຈັດສົ່ງ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>{orderGroupData?.code}</h5>
                                </Col>
                                <Col>
                                    <h5>{covertTimeZone(orderGroupData?.createdAt)}</h5>
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                    <div className="w-full space-y-4">
                        {/* Header Section */}
                        <Row className="mb-4">
                            <Col md={6}>
                                <div className="text-sm" style={{lineHeight:0.5}}>
                                    <h6>ຂໍ້ມູນລູກຄ້າ</h6>
                                    <p>ຊື່: {orderGroupData?.userConfirm?.name ?? orderGroupData?.customerName ?? ""} {orderGroupData?.customerLastName ?? ""}</p>
                                    <p>ໄອດີລູກຄ້າ: {orderGroupData?.userConfirm?.userCode ?? ""}</p>
                                    <p>ທີ່ຢູ່ບ້ານ: {orderGroupData?.userConfirm?.address?.village ?? "..."}, ເມືອງ: {orderGroupData?.userConfirm?.address?.district ?? "...."}, ແຂວງ: {orderGroupData?.userConfirm?.address?.province ?? "..."}</p>
                                    <p>ເບີໂທ: {orderGroupData?.userConfirm?.phone ?? ""}</p>
                                </div>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>ຮູບແບບການຂາຍ</Form.Label>
                                            <Form.Control as="select" defaultValue="PAY_IN_CASH" style={{ border: 'none' }}>
                                                <option value="PAY_IN_CASH">ຈ່າຍສົດ</option>
                                                <option value="FREE_EXAMPLE">ຟຣີ ແລະ ຕົວຢ່າງ</option>
                                                <option value="CREDIT">ເຄດິດ</option>
                                                <option value="STOCK_BRAND">ສະຕ່ອກແຟນຊາຍ</option>
                                                <option value="STOCK_OTHER">ສະຕ່ອກຕ່າງໆ</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>ຂໍ້ມູນພະນັກງານຂາຍ</Form.Label>
                                            <p>ຊື່: {orderGroupData?.createdBy?.firstName ?? "" ?? orderGroupData?.staff + " " + orderGroupData?.createdBy?.lastName ?? "" ?? orderGroupData?.staffLastname ?? ''}</p>
                                            <p>ໄອດີເຊວ: {orderGroupData?.createdBy?.staffCode ?? ''}</p>
                                        </Form.Group>
                                    </Col>
                                </Row>


                            </Col>
                        </Row>

                        <Row>
                            <Col className="text-center">ວັນທີ່ຈະຈ່າຍເງິນ</Col>
                            <Col className="text-center">ຮູບແບບການຈັດສົ່ງ</Col>
                            <Col className="text-center">ສາຂາ ຫຼື ບ່ອນຈັດສົ່ງ</Col>
                            <Col className="text-center">ສະກຸນເງິນ</Col>
                        </Row>
                        <Row>
                            <Col className="text-center p-4">....../...../.......</Col>
                            <Col className="text-center p-4">................</Col>
                            <Col className="text-center p-4">................</Col>
                            <Col className="text-center p-4">{orderGroupData?.currency}</Col>
                        </Row>

                        {/* Main Table */}
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center">NO</th>
                                    <th className="text-center">ເລກລອດ</th>
                                    <th className="text-center">ຊື່ຜະລິດຕະພັນ</th>
                                    <th className="text-center">ຂໍ້ມູນຈຳເພາະ</th>
                                    <th className="text-center">ຈຳນວນຂາຍ</th>
                                    <th className="text-center">ແຖມ</th>
                                    <th className="text-center">ລາຄາ</th>
                                    <th className="text-center">ຈຳນວນເງິນ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderLists.map((row, _index) => (
                                    <tr key={row?.id}>
                                        <td className="text-center">{_index + 1}</td>
                                        <td>{row?.stock?.survivalId?.survivalNumber ?? "-"}</td>
                                        <td>{row?.productName}</td>
                                        <td>-</td>
                                        <td>{row?.amount} {row?.stock?.unit ?? row?.stock?.unitId?.name ?? ""}</td>
                                        <td>{row?.amountFree ?? 0}</td>
                                        <td>{convertCurrency(row?.currency ?? "ກີບ")}{numberFormat(row?.price)} </td>
                                        <td>{convertCurrency(row?.currency ?? "ກີບ")}{numberFormat(row?.totalPrice ?? 0)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {/* Footer Section */}
                        <Row className="mt-4">
                            <Col md={8}>
                                <div className="space-y-2">
                                    <p className="font-medium">ບັນຊີທະນາຄານ:</p>
                                    <p style={{ marginTop: -8 }}>ຊື່ບັນຊີ: {bankAccount[0]?.bankUser ?? "-"}</p>
                                    <div className="d-flex justify-content-around align-items-start pr-8">
                                        <div className="d-flex gap-1 w-100">
                                            <div className="pl-4 space-y-1 " style={{ lineHeight: 0.5 }}>
                                                {bankAccount?.map((bank, _index) => (
                                                    <p key={bank?.id}>ເລກບັນຊີທີ {_index + 1}: {" "} {bank?.bankAccount ?? "-"}</p>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ border: '1px solid gray', width: 220, height: 140, marginRight: '5em', marginTop: "-4em" }}>
                                            <img src={S3_URL + bankAccount[0]?.image} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="space-y-2">
                                    <div className="d-flex justify-content-between">
                                        <span>ລວມເປັນເງິນ</span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.totalPrice)} ₭</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span></span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.sumPriceBaht)} ฿</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span></span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.sumPriceUsd)} $</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>ສ່ວນຫຼຸດ</span>
                                        <span>{orderGroupData?.discount ?? 0}%</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>{orderGroupData?.costTitle ?? "ຄ່າຂົນສົ່ງ"}</span>
                                        <span>{orderGroupData?.shippingCost ?? 0}</span>
                                    </div>
                                    <div className="d-flex justify-content-between font-weight-bold">
                                        <h5>ຈຳນວນເງິນທີ່ຕ້ອງຈ່າຍ</h5>
                                        <h5>{numberFormat(orderGroupData?.sumPrice ?? 0)} {convertCurrency(orderGroupData?.currency)}</h5>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="text-center italic mt-4">
                            Thank you for trusting our company!! ຂອບໃຈທີ່ໄວ້ວາງໃຈໃຫ້ບໍລິການຈາກພວກເຮົາ!!
                        </div>
                    </div>

                    <Row className="pt-5">
                        <Col className="text-center">
                            <p>Inspector's Signature <br /> ລາຍເຊັນຜູ້ກວດກາ</p>
                            <br />
                            <br />
                            <br />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Recipient Signature <br /> ລາຍເຊັນຜູ້ຮັບ</p>
                            <br />
                            <br />
                            <br />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Delivery Person Signature <br /> ລາຍເຊັນຜູ້ສົ່ງ</p>
                            <br />
                            <br />
                            <br />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Payee's Signature <br /> ລາຍເຊັນຜູ້ຮັບເງິນ</p>
                            <br />
                            <br />
                            <br />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </div>
    );
}


const syleBorder = {
    border: '1px solid #ccc',
}

